import { UserState } from '../../types/user/user.def';
import {
  SET_USER,
  SET_USER_NOTIFICATION,
  UPDATE_AVATAR,
  UPDATE_USER
} from '../actions/user.actions';

const userReducer = (
  state: UserState | Record<string, unknown> = {},
  action
) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        ...action.payload
      };
    case SET_USER_NOTIFICATION:
      return {
        ...state,
        options: {
          notifications: [...action.payload]
        }
      };
    case UPDATE_AVATAR:
      return {
        ...state,
        avatar: { media: { url: action.payload } }
      };
    case UPDATE_USER:
      return {
        ...state,
        ...action.payload
      };
    case 'CLEAR_USER':
      return {};
    default:
      return state;
  }
};
export default userReducer;
